import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import Link from 'shared/components/Link';
import { getApiBaseUrl } from 'shared/helper/request';
import Popover from 'researcher/components/Popover';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import DropdownActionsMenu from 'researcher/components/DropdownActionsMenu';
import { CancelFapiaoLink } from 'researcher/fapiao';
var InvoiceActions = function InvoiceActions(_ref) {
  var onFapiaoCancelled = _ref.onFapiaoCancelled,
    invoice = _ref.invoice;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var invoiceCurrency = useSelector(function (_ref2) {
    var payment = _ref2.payment;
    return payment.currencies.find(function (currency) {
      return currency.isoCode === invoice.currency;
    });
  });
  return /*#__PURE__*/React.createElement(DropdownActionsMenu, {
    render: function render(_ref3) {
      var dismissDropdown = _ref3.dismissDropdown;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !invoice.pendingWriteoff && invoice.balance > 0 && invoice.boletoUrl ? /*#__PURE__*/React.createElement("a", {
        "aria-label": t('download boleto'),
        className: "d-block m-1 p-2",
        href: invoice.boletoUrl,
        title: t('download boleto'),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: dismissDropdown
      }, /*#__PURE__*/React.createElement(T, {
        source: "download boleto"
      })) : null, !invoice.pendingWriteoff && invoice.balance > 0 ? /*#__PURE__*/React.createElement(Link, {
        className: "d-block m-1 p-2",
        to: "/researcher/invoices/pay/".concat(encodeURIComponent(invoice.invoiceNumber)),
        title: t('Pay now'),
        onClick: dismissDropdown
      }, /*#__PURE__*/React.createElement(T, {
        source: "Pay now"
      })) : null, invoice.statementOfDelivery ? /*#__PURE__*/React.createElement(React.Fragment, null, invoice.statementOfDeliveryPending ? /*#__PURE__*/React.createElement("span", {
        className: "d-block text-muted m-1 p-2"
      }, /*#__PURE__*/React.createElement(Popover, {
        content: "statement-of-delivery-pending"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        className: "me-1",
        icon: "fa-solid fa-circle-exclamation"
      })), /*#__PURE__*/React.createElement(T, {
        source: "Download statement of delivery"
      })) : /*#__PURE__*/React.createElement("a", {
        "aria-label": t('Download statement of delivery'),
        className: "d-block m-1 p-2",
        href: "".concat(getApiBaseUrl(), "/api/invoice/").concat(invoice.invoiceNumber, "/statement-of-delivery"),
        title: t('Download statement of delivery'),
        onClick: dismissDropdown
      }, /*#__PURE__*/React.createElement(T, {
        source: "Download statement of delivery"
      }))) : null, /*#__PURE__*/React.createElement("a", {
        "aria-label": t('Download invoice as PDF'),
        className: "d-block m-1 p-2",
        href: "".concat(getApiBaseUrl(), "/api/invoice/").concat(invoice.invoiceNumber, "/pdf?localization=").concat(invoice.localization),
        onClick: dismissDropdown,
        title: t('Download invoice as PDF')
      }, /*#__PURE__*/React.createElement(T, {
        source: "Download invoice as PDF"
      })), /*#__PURE__*/React.createElement(CancelFapiaoLink, {
        fapiao: invoice.fapiao,
        onFapiaoCancelled: onFapiaoCancelled,
        paymentDate: invoice.transactionDate
      }), invoice.payments.map(function (payment) {
        return /*#__PURE__*/React.createElement("a", {
          "aria-label": t('receipt-download-link2', payment.amount),
          className: "d-block m-1 p-2",
          key: payment.id,
          href: "".concat(getApiBaseUrl(), "/api/payment/").concat(payment.id, "/pdf?invoice_number=").concat(invoice.invoiceNumber, "&amount=").concat(payment.amount, "&localization=").concat(invoice.localization),
          onClick: dismissDropdown,
          title: t('receipt-download-link2', payment.amount)
        }, /*#__PURE__*/React.createElement(T, {
          source: "receipt-download-link2",
          params: price(invoiceCurrency, payment.amount)
        }));
      }), /*#__PURE__*/React.createElement("a", {
        "aria-label": t('get-support'),
        className: "d-block m-1 p-2",
        href: "".concat(getApiBaseUrl(), "/support"),
        target: "_blank",
        onClick: dismissDropdown,
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(T, {
        source: "get-support"
      })));
    }
  });
};
export default InvoiceActions;